import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // 1. Import useNavigate

function ConsultationButton() {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate(); // 2. Initialize the navigate function

  useEffect(() => {
    const handleScroll = () => {
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      const scrollThreshold = (scrollHeight - clientHeight) * 0.5;
      
      if (window.scrollY > scrollThreshold) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <button
      // 3. Update the onClick to use navigate
      onClick={() => navigate("/contact")} 
      className={`fixed bottom-6 left-6 z-[9999] h-14 rounded-full flex items-center justify-center shadow-lg transition-all duration-500 ease-in-out transform border border-[#B8860B]/20
        ${isVisible 
          ? "opacity-100 translate-y-0 scale-100" 
          : "opacity-0 translate-y-10 scale-50 pointer-events-none"
        } 
        bg-[#B8860B] text-white px-5 hover:bg-[#8B6914] hover:scale-105 hover:shadow-xl group`}
    >
      {/* Icon (Optional: You could change this to a Mail icon if preferred) */}
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        fill="none" viewBox="0 0 24 24" 
        strokeWidth={2} 
        stroke="currentColor" 
        className="w-6 h-6"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z" />
      </svg>

      <span className="ml-2 font-bold uppercase tracking-tight text-xs sm:text-sm">
        Consultation
      </span>
    </button>
  );
}

export default ConsultationButton;